import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7713b13"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-hero-hexgrid" }, null, -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-hero-shockwave" }, null, -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-hero-scanline" }, null, -1 /* HOISTED */))
const _hoisted_4 = { class: "nge-hero-card" }
const _hoisted_5 = { class: "nge-hero-particles" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-hero-rings" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "nge-hero-ring nge-hero-ring--1" }),
  /*#__PURE__*/_createElementVNode("div", { class: "nge-hero-ring nge-hero-ring--2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "nge-hero-ring nge-hero-ring--3" })
], -1 /* HOISTED */))
const _hoisted_7 = { class: "nge-hero-orbits" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-hero-aura" }, null, -1 /* HOISTED */))
const _hoisted_9 = { class: "nge-hero-icon" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  class: "nge-hero-emoji"
}
const _hoisted_12 = { class: "nge-hero-title-wrap" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-hero-label" }, "ACHIEVEMENT UNLOCKED", -1 /* HOISTED */))
const _hoisted_14 = { class: "nge-hero-title" }
const _hoisted_15 = { class: "nge-hero-subtitle" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-hero-hint" }, "Click to view profile", -1 /* HOISTED */))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-cell-chip-check",
  "aria-hidden": "true"
}, "✓", -1 /* HOISTED */))
const _hoisted_18 = { class: "nge-cell-chip-title" }
const _hoisted_19 = {
  key: 0,
  class: "nge-cell-chip-count"
}
const _hoisted_20 = {
  key: 0,
  class: "nge-cell-chip-count"
}
const _hoisted_21 = {
  key: 1,
  class: "nge-cell-chip-count"
}
const _hoisted_22 = { class: "nge-cell-card" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "nge-cell-text" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cell-congrats" }, "Congratulations, Cell Complete!", -1 /* HOISTED */))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cell-thanks" }, "Thank you for helping to map the brain. For science!", -1 /* HOISTED */))
const _hoisted_27 = {
  key: 0,
  class: "nge-cell-stats"
}
const _hoisted_28 = {
  key: 1,
  class: "nge-cell-stats nge-cell-stats--all"
}
const _hoisted_29 = {
  key: 2,
  class: "nge-cell-stats"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cell-hint" }, "Click to dismiss", -1 /* HOISTED */))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-batch-vignette" }, null, -1 /* HOISTED */))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-batch-hexgrid" }, null, -1 /* HOISTED */))
const _hoisted_33 = { class: "nge-batch-rays" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-batch-shockwave" }, null, -1 /* HOISTED */))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-batch-shockwave nge-batch-shockwave--2" }, null, -1 /* HOISTED */))
const _hoisted_36 = { class: "nge-batch-particles" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-batch-corner nge-batch-corner--tl" }, null, -1 /* HOISTED */))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-batch-corner nge-batch-corner--tr" }, null, -1 /* HOISTED */))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-batch-corner nge-batch-corner--bl" }, null, -1 /* HOISTED */))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-batch-corner nge-batch-corner--br" }, null, -1 /* HOISTED */))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-batch-aura" }, null, -1 /* HOISTED */))
const _hoisted_42 = { class: "nge-batch-halo" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-batch-scanline" }, null, -1 /* HOISTED */))
const _hoisted_44 = { class: "nge-batch-pyr-wrap" }
const _hoisted_45 = ["src"]
const _hoisted_46 = { class: "nge-batch-orbits" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-batch-label" }, "CELLS COMPLETE", -1 /* HOISTED */))
const _hoisted_48 = { class: "nge-batch-count" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-batch-cells-text" }, "cells added to the connectome", -1 /* HOISTED */))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-batch-divider" }, null, -1 /* HOISTED */))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-batch-total-label" }, "YOUR TOTAL", -1 /* HOISTED */))
const _hoisted_52 = { class: "nge-batch-total" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-batch-total-sub" }, "cells mapped", -1 /* HOISTED */))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-batch-thanks" }, "Thank you for mapping the brain!", -1 /* HOISTED */))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-batch-rally" }, "FOR SCIENCE!", -1 /* HOISTED */))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-qcard-eyebrow" }, "Quest complete", -1 /* HOISTED */))
const _hoisted_57 = { class: "nge-qcard-cell" }
const _hoisted_58 = { class: "nge-qcard-stats" }
const _hoisted_59 = { class: "nge-qcard-stat" }
const _hoisted_60 = { class: "nge-qcard-num" }
const _hoisted_61 = { class: "nge-qcard-label" }
const _hoisted_62 = { class: "nge-qcard-stat" }
const _hoisted_63 = { class: "nge-qcard-num nge-qcard-num--total" }
const _hoisted_64 = { class: "nge-qcard-label" }
const _hoisted_65 = { class: "nge-toast-container" }
const _hoisted_66 = ["onClick"]
const _hoisted_67 = { class: "nge-toast-particles" }
const _hoisted_68 = { class: "nge-toast-icon" }
const _hoisted_69 = ["src"]
const _hoisted_70 = {
  key: 1,
  class: "nge-toast-emoji"
}
const _hoisted_71 = { class: "nge-toast-text" }
const _hoisted_72 = { class: "nge-toast-title" }
const _hoisted_73 = { class: "nge-toast-subtitle" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-toast-progress" }, null, -1 /* HOISTED */))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["ConfettiCelebration"], { ref: "confettiRef" }, null, 512 /* NEED_PATCH */),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createCommentVNode(" Hero badge unlock overlay — full-screen sci-fi spectacle "),
      _createVNode(_Transition, { name: "nge-hero" }, {
        default: _withCtx(() => [
          ($setup.heroBadge)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "nge-hero-overlay",
                onClick: $setup.onHeroClick
              }, [
                _createCommentVNode(" Hex grid background "),
                _hoisted_1,
                _createCommentVNode(" Shockwave ring "),
                _hoisted_2,
                _createCommentVNode(" Vertical energy scan "),
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  _createCommentVNode(" Multi-layer particles "),
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(20, (i) => {
                      return _createElementVNode("span", {
                        key: i,
                        class: "nge-hero-particle",
                        style: _normalizeStyle({ '--i': i })
                      }, null, 4 /* STYLE */)
                    }), 64 /* STABLE_FRAGMENT */))
                  ]),
                  _createCommentVNode(" Rotating holographic rings "),
                  _hoisted_6,
                  _createCommentVNode(" Orbital electron dots "),
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                      return _createElementVNode("span", {
                        key: i,
                        class: "nge-hero-orbit-dot",
                        style: _normalizeStyle({ '--j': i })
                      }, null, 4 /* STYLE */)
                    }), 64 /* STABLE_FRAGMENT */))
                  ]),
                  _createCommentVNode(" Pulsing energy aura "),
                  _hoisted_8,
                  _createCommentVNode(" Badge icon "),
                  _createElementVNode("div", _hoisted_9, [
                    ($setup.heroBadge.isImage)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: $setup.heroBadge.icon,
                          class: "nge-hero-badge-img"
                        }, null, 8 /* PROPS */, _hoisted_10))
                      : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($setup.heroBadge.icon), 1 /* TEXT */))
                  ]),
                  _createCommentVNode(" Glitch-reveal title "),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, _toDisplayString($setup.heroBadge.title), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_15, _toDisplayString($setup.heroBadge.subtitle), 1 /* TEXT */),
                  _hoisted_16
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _createCommentVNode(" The small note (Settings: \"A small note at the top\"): one line under\n         the top bar that covers nothing and takes no clicks from the view. "),
      _createVNode(_Transition, { name: "nge-cell-chip" }, {
        default: _withCtx(() => [
          ($setup.cellCelebration && $setup.cellMessageMode === 'small')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "nge-cell-chip",
                title: "Click to dismiss",
                onClick: $setup.dismissCellCelebration
              }, [
                _hoisted_17,
                _createElementVNode("span", _hoisted_18, _toDisplayString($setup.cellCelebration.batchCount && $setup.cellCelebration.batchCount > 1 ? $setup.cellCelebration.batchCount + ' cells complete' : 'Cell complete'), 1 /* TEXT */),
                ($setup.cellCelebration.batchCount && $setup.cellCelebration.batchCount > 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                      _createElementVNode("b", null, _toDisplayString($setup.cellCelebration.totalCells), 1 /* TEXT */),
                      _createTextVNode(" in all")
                    ]))
                  : ($setup.cellCelebration.counted)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        ($setup.cellCelebration.datasetLabel)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                              _createTextVNode(_toDisplayString($setup.cellCelebration.datasetLabel) + " ", 1 /* TEXT */),
                              _createElementVNode("b", null, _toDisplayString($setup.cellCelebration.datasetCells), 1 /* TEXT */)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_21, [
                              _createElementVNode("b", null, _toDisplayString($setup.cellCelebration.totalCells), 1 /* TEXT */),
                              _createTextVNode(" in all")
                            ]))
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _createCommentVNode(" Single-cell celebration overlay (compact) "),
      _createVNode(_Transition, { name: "nge-cell-celebrate" }, {
        default: _withCtx(() => [
          ($setup.cellCelebration && $setup.cellMessageMode === 'full' && (!$setup.cellCelebration.batchCount || $setup.cellCelebration.batchCount <= 1))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "nge-cell-overlay",
                onClick: $setup.dismissCellCelebration
              }, [
                _createElementVNode("div", _hoisted_22, [
                  ($setup.cellCelebration.imageUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $setup.cellCelebration.imageUrl,
                        class: "nge-cell-nurro"
                      }, null, 8 /* PROPS */, _hoisted_23))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _hoisted_26,
                    _createCommentVNode(" No number until both are counted, so a stale one never flashes first. "),
                    ($setup.cellCelebration.counted)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          ($setup.cellCelebration.datasetLabel)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _createTextVNode("+1 cell brings your " + _toDisplayString($setup.cellCelebration.datasetLabel) + " total to ", 1 /* TEXT */),
                                _createElementVNode("strong", null, _toDisplayString($setup.cellCelebration.datasetCells), 1 /* TEXT */)
                              ]))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" A second line only when there is more to say: with every cell on\n                 one dataset it would repeat the number above. "),
                          ($setup.cellCelebration.datasetLabel && $setup.cellCelebration.totalCells > ($setup.cellCelebration.datasetCells ?? 0))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString($setup.cellCelebration.totalCells) + " cells across all datasets", 1 /* TEXT */))
                            : (!$setup.cellCelebration.datasetLabel)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  _createTextVNode("+1 cell brings your total to "),
                                  _createElementVNode("strong", null, _toDisplayString($setup.cellCelebration.totalCells), 1 /* TEXT */)
                                ]))
                              : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _hoisted_30
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _createCommentVNode(" Batch celebration overlay — Asgardian hero treatment "),
      _createVNode(_Transition, { name: "nge-batch-celebrate" }, {
        default: _withCtx(() => [
          ($setup.cellCelebration && $setup.cellMessageMode === 'full' && $setup.cellCelebration.batchCount && $setup.cellCelebration.batchCount > 1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "nge-batch-overlay",
                onClick: $setup.dismissCellCelebration
              }, [
                _hoisted_31,
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (i) => {
                    return _createElementVNode("div", {
                      key: i,
                      class: "nge-batch-ray",
                      style: _normalizeStyle({ '--i': i - 1 })
                    }, null, 4 /* STYLE */)
                  }), 64 /* STABLE_FRAGMENT */))
                ]),
                _hoisted_34,
                _hoisted_35,
                _createCommentVNode(" Background dust — particles rise with organic noise (wandering side-to-side). "),
                _createElementVNode("div", _hoisted_36, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(50, (i) => {
                    return _createElementVNode("span", {
                      key: i,
                      class: "nge-batch-particle",
                      style: _normalizeStyle({ '--i': i })
                    }, null, 4 /* STYLE */)
                  }), 64 /* STABLE_FRAGMENT */))
                ]),
                _createElementVNode("div", {
                  class: "nge-batch-card",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("button", {
                    class: "nge-batch-close",
                    onClick: $setup.dismissCellCelebration,
                    "aria-label": "Dismiss"
                  }, "×"),
                  _hoisted_37,
                  _hoisted_38,
                  _hoisted_39,
                  _hoisted_40,
                  _hoisted_41,
                  _createCommentVNode(" Halo cloud — 60 particles in 3 concentric bands at varying radii.\n               Replaces the previous solid rotating rings with something softer and gaseous. "),
                  _createElementVNode("div", _hoisted_42, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(72, (i) => {
                      return _createElementVNode("span", {
                        key: i,
                        class: "nge-batch-halo-particle",
                        style: _normalizeStyle({ '--i': i - 1 })
                      }, null, 4 /* STYLE */)
                    }), 64 /* STABLE_FRAGMENT */))
                  ]),
                  _hoisted_43,
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("img", {
                      src: $setup.pyrIcon,
                      class: "nge-batch-pyr",
                      alt: "Pyr"
                    }, null, 8 /* PROPS */, _hoisted_45),
                    _createCommentVNode(" Orbital particles around the Pyr icon — replaces the Norse runes\n                 with something more elegant: 24 small dots in 3 orbital bands at\n                 different speeds, like electrons / planets. "),
                    _createElementVNode("div", _hoisted_46, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(24, (i) => {
                        return _createElementVNode("span", {
                          key: i,
                          class: "nge-batch-orbit",
                          style: _normalizeStyle({ '--i': i - 1 })
                        }, null, 4 /* STYLE */)
                      }), 64 /* STABLE_FRAGMENT */))
                    ])
                  ]),
                  _hoisted_47,
                  _createElementVNode("div", _hoisted_48, "+" + _toDisplayString($setup.cellCelebration.batchCount), 1 /* TEXT */),
                  _hoisted_49,
                  _hoisted_50,
                  _hoisted_51,
                  _createElementVNode("div", _hoisted_52, _toDisplayString($setup.cellCelebration.totalCells), 1 /* TEXT */),
                  _hoisted_53,
                  _hoisted_54,
                  _hoisted_55
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _createCommentVNode(" A completed quest: the counts, in a holo card at the top. "),
      _createVNode(_Transition, { name: "nge-qcard" }, {
        default: _withCtx(() => [
          ($setup.questCard)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                ref: "questCardEl",
                class: "nge-qcard",
                onClick: $setup.closeQuestCard,
                role: "status"
              }, [
                _hoisted_56,
                _createElementVNode("div", _hoisted_57, _toDisplayString($setup.questCard.index || 'Cell'), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, _toDisplayString($setup.questCard.points), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_61, _toDisplayString($setup.questCard.points === 1 ? 'annotation' : 'annotations') + " on this cell", 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, _toDisplayString($setup.questCard.done), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_64, _toDisplayString($setup.questCard.done === 1 ? 'quest' : 'quests') + " completed by you", 1 /* TEXT */)
                  ])
                ])
              ], 512 /* NEED_PATCH */))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_65, [
        _createVNode(_TransitionGroup, { name: "nge-toast" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.toasts, (toast) => {
              return (_openBlock(), _createElementBlock("div", {
                key: toast.id,
                class: _normalizeClass(["nge-toast", [
            `nge-toast--${toast.type}`,
            { 'nge-toast--leaving': toast.leaving },
          ]]),
                onClick: $event => ($setup.dismiss(toast.id))
              }, [
                _createCommentVNode(" Sparkle particles "),
                _createElementVNode("div", _hoisted_67, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i) => {
                    return _createElementVNode("span", {
                      key: i,
                      class: "nge-toast-particle",
                      style: _normalizeStyle({ '--i': i })
                    }, null, 4 /* STYLE */)
                  }), 64 /* STABLE_FRAGMENT */))
                ]),
                _createCommentVNode(" Icon "),
                _createElementVNode("div", _hoisted_68, [
                  (toast.isImage)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: toast.icon,
                        class: "nge-toast-badge-img"
                      }, null, 8 /* PROPS */, _hoisted_69))
                    : (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(toast.icon), 1 /* TEXT */))
                ]),
                _createCommentVNode(" Text "),
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, _toDisplayString(toast.title), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_73, _toDisplayString(toast.subtitle), 1 /* TEXT */)
                ]),
                _createCommentVNode(" Progress bar (auto-dismiss countdown) "),
                _hoisted_74
              ], 10 /* CLASS, PROPS */, _hoisted_66))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}